import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { customerProductParam, jobIdParam, orgIdParam } from './builderHelper';

export const scheduledResources = {
  getOrganizationTasks: createResourceBuilder(
    '/admin/cron-jobs/organization/:organization_id',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getOrganizationProductTasks: createResourceBuilder(
    '/admin/cron-jobs/organization/:organization_id/product/:customer_product_id',
    EResourceMethod.Get,
    orgIdParam(customerProductParam())
  ),
  cancelJob: createResourceBuilder('/admin/cron-jobs/:job_id', EResourceMethod.Delete, jobIdParam()),
  getAllJobs: createResourceBuilder('/admin/cron-jobs', EResourceMethod.Get),
  getJob: createResourceBuilder('/admin/cron-jobs/:job_id', EResourceMethod.Get, jobIdParam()),
};
